export const MOVEMENT_UNDO_CONFLICTS = {
  // Исходную ячейку отряда уже занял другой отряд
  ORIGIN_OCCUPIED: 'origin_occupied',
};

/**
 * Можно ли отменить перемещение отряда вне очереди (двойной клик по нему) —
 * вернуть его на исходную ячейку, не сделав задним числом невозможным ни одно
 * из более поздних перемещений этого этапа.
 *
 * Кнопка отмены снимает перемещения строго с конца, и у нее такого вопроса
 * нет. Вне очереди помешать может только одно: исходную ячейку уже занял
 * отряд, пришедший туда позже. Путей более поздних перемещений вернувшийся
 * отряд не рвет — свой отряд проходим ровно там, где проходима сама ячейка
 * (пустая — только при Экоанархизме, см. calculateAvailableMovementCells),
 * так что его возвращение не перекрывает ничего, кроме самой этой ячейки.
 *
 * Возвращает null, если отмена возможна, иначе {reason, unitId}, где unitId —
 * отряд, чье перемещение нужно отменить раньше.
 */
export const findMovementUndoConflict = ({
  unitId,
  pendingMovementActions,
  units,
}) => {
  const undoneIndex = pendingMovementActions.findIndex((movement) => movement.unitId === unitId);
  if (undoneIndex === -1) {
    return null;
  }
  const {fromHexKey} = pendingMovementActions[undoneIndex];

  const originOccupant = units.find((unit) => unit.hexKey === fromHexKey && unit.id !== unitId);
  if (originOccupant) {
    return {reason: MOVEMENT_UNDO_CONFLICTS.ORIGIN_OCCUPIED, unitId: originOccupant.id};
  }

  return null;
};
